import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import Select  from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import useQuery from '../../../hooks/use-query-params';
import mockLists from './items-mock';
import { mapObjToQueryString } from '../../utils';
import { FormattedMessage } from 'react-intl';
import m from './messages';
export default function ItemsPerPage({ countType }) {
  // routes data
  const parsedQueryInObj = useQuery();
  const history = useHistory();
  const { pathname } = useLocation();

  // state
  const [ listItems, setListItems ] = useState(mockLists[countType]);
  const [ selected, setSelected ] = useState(parsedQueryInObj.itemsPerPage || listItems[0].value);


  useEffect(
    () => {
      setListItems(mockLists[countType]);
    }, [countType]
  )

  const handleChange = ({ target: { value } }) => {
    setSelected(value);

    delete parsedQueryInObj.page; // remove page property
    const url = `${pathname}${mapObjToQueryString(parsedQueryInObj, { itemsPerPage: value })}`;
    history.push(url)
  }

  return (
    <div className='paging__count-list'>
      <Select
        value={selected}
        onChange={handleChange}
      >
        { listItems.map(({ value, name }) => (
          <MenuItem key={name} className='paging__count-item' value={value}>{name}</MenuItem>)) 
        }
      </Select>
      <span className='paging__count-text'>{<FormattedMessage {...m.resultsPerPage}/>}</span>
    </div>
  )
}


ItemsPerPage.propTypes = {
  countType: PropTypes.string
}

ItemsPerPage.defaultProps = {
  countType: 'fifty'
}